import { ROUTE } from 'utils/constants';

const config = {
  PATH: ROUTE.CLIENT_REDIRECT,
  ID: 'CLIENT_REDIRECT',
  SIDEBAR_IMAGE: false,
  BUTTON_HELP: true,
  BUTTON_LANG: true,
  BUTTON_QUIT: true,
};

export default config;
